export enum AppLanguage {
  JAPANESE = 'ja',
  VIETNAMESE = 'vi',
}
